
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import ptLocale from '@fullcalendar/core/locales/pt-br'
import { subHours, format, parseISO } from 'date-fns';
import interactionPlugin from '@fullcalendar/interaction';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
export default {
	components: {
		FullCalendar,
	},
	data() {
		return {
			baseURL: window.location.origin,
			GLOBAL: GLOBAL,
			events: [],
			columns: [
				{
					name: 'nome',
					required: true,
					label: 'nome',
					align: 'left',
					sortable: true
				},
				{ name: 'valor_total', align: 'left', label: 'Valor total', field: 'valor_total', sortable: true },


			],
			rows: [
				{
					id: 1,
					name: 'Nome',
					valor_total: 'R$ 100,00',
				}
			],
			modalDividendo: null,
			calendarOptions: {
				plugins: [dayGridPlugin, interactionPlugin],
				initialView: 'dayGridMonth',
				weekends: false,
				timezone: 'UTC',
				locales: [ptLocale],
				events: this.events,
				dateClick: this.onClickEvent,
				datesSet: this.getTotalByMonth,
				displayEventTime: false,
				showNonCurrentDates: false,
		
			},
			calendarRef: null,
			eventDay: null,
			dayClicked: "",
			totalMonth: 0,
			eventsDates: new Set(),

		}
	},
	methods: {
		formatToCalendar(arr, formato = "yyyy-MM-dd'T'HH:mm:ss") {
			const result = arr
				.filter((i) => i.payment_date)
				.map((i) => {
					const dataFinal = parseISO(i.payment_date)
					const entregaDataFormated = format(dataFinal, 'dd/MM/yyyy HH:mm')

					return {
						id: i.id,
						title: GLOBAL.fMoney(i.net_value),
						start: i.payment_date,
						end: entregaDataFormated,
						color: 'green',
						extendedProps: { ...i },
						allDay: false,

					}
				})
			return result
		},
		fMoney(val) {
			return Number(val).toLocaleString('pt-BR', {
				style: 'currency',
				currency: 'BRL',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			})
		},
		async getEvents() {
			try {
				const { data } = await axios.get(
					`${this.baseURL}/api/calendario_dividendo/`
				);
				this.events = data
			} catch (error) {
				console.log(error);
			}
		},
		async getEventByDate(date) {
			try {
				const { data } = await axios.get(
					`${this.baseURL}/api/calendario_dividendo/?data_pagamento=${date}`
				);

				this.eventDay = data
				return data
			} catch (error) {
				console.log(error);
			}
		},
		async getTotalByMonth(date) {

			try {

				const dateFormat = format(new Date(date.startStr), 'yyyy-MM')
				const { data } = await axios.get(
					`${this.baseURL}/api/calendario_dividendo/total_dividendos_pagos/?data=${dateFormat}`
				);

				this.totalMonth = this.fMoney(data.total_dividendos)
				const days = document.querySelectorAll('.fc-daygrid-day')
				days.forEach((day) => {
					const date = day.getAttribute('data-date')
					const data = this.events.filter((i) => i.start === date)
					if (data.length > 0) {
						day.classList.add('has-event')
					}
					tippy('.fc-day.has-event', {
						content: 'Clique para ver os detalhes sobre o evento',
					})
				})
			} catch (error) {
				console.log(error);
			}
		},
		setModalDividendo() {
			this.modalDividendo = ModalX('.modal-dividendo', {
				deep: true,
				zIndex: 300000,
				zIndexDeep: 20000,
				closeOnDeep: false,
				bgModal: 'rgb(30,33,36)'
			}).init()
		},
		async onClickEvent({ dateStr }) {
			const response = await this.getEventByDate(dateStr)
			if(!response?.length) return
			this.modalDividendo?.openModal(1)
			const nextDay = new Date(dateStr).getDate() + 1
			const correctDate = new Date(dateStr).setDate(nextDay)
			this.dayClicked = format(new Date(correctDate), 'dd/MM/yyyy')
		},

	},
	computed: {
		isMobile() {
			return window.innerWidth <= 768
		}
	},
	watch: {
		events: {
			handler(newVal) {
				this.$refs.calendarRef?.getApi().removeAllEvents()
				this.$refs.calendarRef?.getApi().addEventSource(newVal)
			},

		},
	},
	async mounted() {

		this.setModalDividendo()
		await this.getEvents()

		this.events = this.formatToCalendar(this.events)
		const days = document.querySelectorAll('.fc-daygrid-day')
		days.forEach((day) => {
			const date = day.getAttribute('data-date')
			const data = this.events.filter((i) => i.start === date)
			if (data.length > 0) {
				day.classList.add('has-event')
			}
			tippy('.fc-day.has-event', {
				content: 'Clique para ver os detalhes sobre o evento',
			})
		})


	},
	delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django
}